
import ServiceHelper from "./service.helper";


export default class ManagerService {

  static API_URL = '/members';
  
  static async signup(payload) {
    return await ServiceHelper.handlePostRequest(this.API_URL+"/user/", payload);
  };
  
  static async verification(payload) {
    return await ServiceHelper.handlePostRequest(this.API_URL+"/verify/", payload);
  };
  
  static async resendOtp(payload) {
    return await ServiceHelper.handlePostRequest(this.API_URL+"/re_verify/", payload);
  };
  
  static  async login (payload) {
    return await ServiceHelper.handlePostRequest(this.API_URL+"/login/", payload)
  };
  
  static  async forgotPassword (payload) {
    return await ServiceHelper.handlePostRequest(this.API_URL+"/forgot_password/", payload)
  };
  
  static  async resetPassowrd (payload) {
    return await ServiceHelper.handlePatchRequest(this.API_URL+"/validate_password/", payload)
  };
  
  static  async logout() {
      localStorage.removeItem("token")
    return await localStorage.removeItem("user");
  };

  static createBusiness(payload) {
    return ServiceHelper.handlePostRequest("/create_business/", payload, {headers:{'Content-Type': 'multipart/form-data'}});
  }

  static async getProfile() {
      return await ServiceHelper.handleGetRequest(this.API_URL+"/user");
  }

  static async getStore() {
      return await ServiceHelper.handleGetRequest(`${this.API_URL}/merchant_details/`);
  }

//   static createBusiness(payload) {
//       return ServiceHelper.handlePostRequest("/create_business/", payload, {headers:{'Content-Type': 'multipart/form-data'}});
//   }

  static updateBusinessInfo(user_id, payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/${user_id}/business`, payload)
  }

  static updateProfilePhoto(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/profile_photo/`, payload)
  }

  static walletDetails() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/wallet_details/`)
  }

  static createUser(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/managers/`, payload)
  }

  static getUsers() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/managers/`)
  }

  static getCustomers() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/customers_list/`)
  }

  static getEmails() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/customer_email/`)
  }

  static getSms() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/customer_sms/`)
  }

  static createSms(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/customer_sms/`, payload)
  }

  static createEmail(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/customer_email/`, payload)
  }

  static deleteSms(id) {
      return ServiceHelper.handleDeleteRequest(`${this.API_URL}/delete_sms/${id}/`)
  }

  static deleteEmail(id) {
      return ServiceHelper.handleDeleteRequest(`${this.API_URL}/delete_email/${id}/`)
  }

  static deleteCustomer(customer_id) {
      return ServiceHelper.handleDeleteRequest(`${this.API_URL}/delete_customer/${customer_id}/`)
  }

  static deleteUser(user_id) {
      return ServiceHelper.handleDeleteRequest(`${this.API_URL}/manage_team/${user_id}/`)
  }

  static saveSocialMedia(payload) {
      return ServiceHelper.handlePatchRequest(`${this.API_URL}/social_media/`, payload)
  }

  static getSocialMedia() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/social_media/`)
  }

  static manageUser(payload) {
      return ServiceHelper.handlePatchRequest(`${this.API_URL}/manage_team/${payload.user_id}/`, payload)
  }

  static withdrawal(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/withdrawal/`, payload)
  }

  static depositFund(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/funds_deposit/`, payload)
  }

  static pinVerification(payload) {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/verify_pin/?wallet_pin=${payload.wallet_pin}`)
  }

  static changePassword(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/change_password/`, payload)
  }

  static accountUpgrade(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/account_upgrade/`, payload)
  }

  static rewards() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/user_referrals/`)
  }

  static customerRating(payload) {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/customer_rating/${payload.merchant_id}`)
  }

  static getNotifications(option) {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/notification/?read=${option}`)
  }

  static transactionHistory(params) {
    let request_params = ``;

    if(params.from_date !== '' && params.from_date !== undefined) {
        request_params += `&from_date=${params.from_date}`; 
    }
    if(params.to_date !== '' && params.to_date !== undefined){
        request_params += `&to_date=${params.to_date}`;
    }
    if(params.filter_by === 'type'){
        request_params += `&transaction_type=${params.filter}`;
    }
    if(params.status !== '' && params.status !== undefined) {
        request_params += `&status=${params.status}`;
    }
    if(params.filter !== '' && params.filter !== undefined) {
        request_params += `&filter=${params.filter}`;
    }
    if(params.filter_by !== '' && params.filter_by !== undefined) {
        request_params += `&filter_by=${params.filter_by}`;
    }
    if(params.sort_by !== '' && params.sort_by !== undefined) {
        request_params += `&sort_by=${params.sort_by}`;
    }
    if(params.download !== '' && params.download !== undefined && params.download === 'True') {
        request_params += `&download=${params.download}`;
    }
    if(params.gateway !== '' && params.gateway !== undefined) {
        request_params += `&gateway=${params.gateway}`;
    }
    if(params.page !== '' && params.page !== undefined) {
        request_params += `&page=${params.page}`;
    }
    request_params = request_params.slice(1)
    return ServiceHelper.handleGetRequest(`${this.API_URL}/transactions/?${request_params}`)
  }

  static claimPaycode(payload){
    return ServiceHelper.handlePostRequest(`${this.API_URL}/voucher/`, payload);
  }

  static createPaycodes(payload){
    return ServiceHelper.handleGetRequest(`${this.API_URL}/voucher/`, payload);
  }

  static getPaycodes(params){
    let request_params = ``;

    if(params.from_date !== '' && params.from_date !== undefined) {
        request_params += `&from_date=${params.from_date}`; 
    }
    if(params.to_date !== '' && params.to_date !== undefined){
        request_params += `&to_date=${params.to_date}`;
    }
    if(params.page !== '' && params.page !== undefined) {
        request_params += `&page=${params.page}`;
    }
    request_params = request_params.slice(1)
    return ServiceHelper.handleGetRequest(`${this.API_URL}/voucher/?${request_params}`);
  }

  static readNotifications(id) {
    return ServiceHelper.handlePatchRequest(`${this.API_URL}/read_notification/${id}/`, {read: true})
  }

  static getVirtualAccounts() {
    return ServiceHelper.handleGetRequest(`${this.API_URL}/virtual_accounts/`)
  }

  static createLoyaltyVoucher(payload){
    return ServiceHelper.handlePostRequest(`${this.API_URL}/loyalty_voucher/`, payload);
  }

  static createBulkLoyaltyVoucher(payload){
    return ServiceHelper.handlePostRequest(`${this.API_URL}/loyalty_voucher_bulk_create/`, payload);
  }

//   static getTaxCalculators(params) {
//       let uri =  `/tax`;
//       if(params.filter_year !== '' && params.filter_year !== undefined && params.filter_month !== '' && params.filter_month !== undefined) {
//           uri = `/tax/?filter_year=${params.filter_year}&filter_month=${params.filter_month}`;
//       }
//       return ServiceHelper.handleGetRequest(`${this.API_URL}${uri}`);
//   }

  // ****************************** Petty Cash *******************************
  static getPettyCashWalletDetails() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/petty_cash_wallet/`);
  }

  static creditPettyCashWallet(payload) {
    return ServiceHelper.handlePostRequest(`${this.API_URL}/petty_cash_wallet/`, payload);
  }

  static getPettyCashWalletLogs(params) {
        const queryParams = new URLSearchParams();
        
        if (params.from_date && params.filter_by !== 'all') {
            queryParams.append('from_date', params.from_date);
        }
        if (params.to_date && params.filter_by !== 'all') {
            queryParams.append('to_date', params.to_date);
        }
        if (params.page) {
            queryParams.append('page', params.page);
        }
        if (params.download) {
            queryParams.append('download', params.download);
        }
        if (params.filter_by && params.filter && params.filter_by !== 'date') {
            queryParams.append('filter', 'transaction_type');
            queryParams.append('filter_value', params.filter);
        }
        
        const url = `${this.API_URL}/petty_cash_log/?${queryParams.toString()}`;

        if(params.download) {
            return ServiceHelper.handleDownloadRequest(url, 'PettyCash_Data')
        }
        
        return ServiceHelper.handleGetRequest(url);
  }

  static getPettyCashBeneficaries() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/merchant_beneficiary/`);
  }

  static createPettyCashBeneficary(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/merchant_beneficiary/`, payload);
  }

  static payPettyCashBeneficary(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/pay_beneficiary/`, payload);
  }

  static managePettyCashRequest(payload) {
      return ServiceHelper.handlePostRequest(`${this.API_URL}/petty_cash_request/`, payload);
  }

  static getPettyCashRequests() {
      return ServiceHelper.handleGetRequest(`${this.API_URL}/petty_cash_request/`);
  }

  static submitPettyCashRequest(payload) {
    return ServiceHelper.handlePostRequest(`${this.API_URL}/petty_cash_request/`, payload);
  }

  static manageTransactionPin(payload) {
    if(payload.action === 'create') {
        return ServiceHelper.handlePostRequest(`${this.API_URL}/pin_management/`, { pin: payload.pin });
    }
    return ServiceHelper.handlePatchRequest(`${this.API_URL}/pin_management/`, { new_pin: payload.pin, current_pin: payload.current_pin });
  }

  static getInvoices(param = 1) {
    return ServiceHelper.handleGetRequest(`${this.API_URL}/merchant_invoice/?page=${param}`);
  }

  static getInvoicesByRef(ref) {
    return ServiceHelper.handleGetRequest(`${this.API_URL}/merchant_invoice/?ref=${ref}`);
  }
  
  static createInvoice(payload) {
    return ServiceHelper.handlePostRequest(`${this.API_URL}/merchant_invoice/`, payload);
  }

  static fasePay(payload){
    return ServiceHelper.handlePostRequest(`${this.API_URL}/fase_pay/`, payload);
  } 

    static async downloadPettyCashLog() {
        return ServiceHelper.handleDownloadRequest(`${this.API_URL}/petty_cash_log/?download=${true}`, 'PettyCash_Data');
    }

    static getTaxCalculators(params) {
        let uri =  `${this.API_URL}/tax`;
        if(params.filter_year !== '' && params.filter_year !== undefined && params.filter_month !== '' && params.filter_month !== undefined) {
            uri = `${this.API_URL}/tax/?filter_year=${params.filter_year}&filter_month=${params.filter_month}`;
        }
        return ServiceHelper.handleGetRequest(`${uri}`);
    }

    static createCustomer(payload) {
        return ServiceHelper.handlePostRequest(`${this.API_URL}/customers_list/`, payload)
    }

    static checkPaycodeBalance(payload) {
        return ServiceHelper.handleGetRequest(`${this.API_URL}/paycode_balance/?token=${payload.paycode}&secret=${payload.secret_word}`);
    }
}    
